/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShopifyStoreLocation } from "./ShopifyStoreLocation";
import {
  ShopifyStoreLocationFromJSON,
  ShopifyStoreLocationFromJSONTyped,
  ShopifyStoreLocationToJSON,
  ShopifyStoreLocationToJSONTyped,
} from "./ShopifyStoreLocation";

/**
 *
 * @export
 * @interface ShopifyStoreLocationsResponse
 */
export interface ShopifyStoreLocationsResponse {
  /**
   *
   * @type {Array<ShopifyStoreLocation>}
   * @memberof ShopifyStoreLocationsResponse
   */
  locations: Array<ShopifyStoreLocation>;
}

/**
 * Check if a given object implements the ShopifyStoreLocationsResponse interface.
 */
export function instanceOfShopifyStoreLocationsResponse(
  value: object,
): value is ShopifyStoreLocationsResponse {
  if (!("locations" in value) || value["locations"] === undefined) return false;
  return true;
}

export function ShopifyStoreLocationsResponseFromJSON(
  json: any,
): ShopifyStoreLocationsResponse {
  return ShopifyStoreLocationsResponseFromJSONTyped(json, false);
}

export function ShopifyStoreLocationsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyStoreLocationsResponse {
  if (json == null) {
    return json;
  }
  return {
    locations: (json["locations"] as Array<any>).map(
      ShopifyStoreLocationFromJSON,
    ),
  };
}

export function ShopifyStoreLocationsResponseToJSON(
  json: any,
): ShopifyStoreLocationsResponse {
  return ShopifyStoreLocationsResponseToJSONTyped(json, false);
}

export function ShopifyStoreLocationsResponseToJSONTyped(
  value?: ShopifyStoreLocationsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    locations: (value["locations"] as Array<any>).map(
      ShopifyStoreLocationToJSON,
    ),
  };
}
